<template>
  <div v-if="requisition && requisition.actions">
    <v-sheet class="pt-1 transparent-background-color d-inline-block">
      <v-tooltip
        top
        v-if="showView && $permission.permissionAllow('Requisitions', 'view')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="info"
            class="px-2 me-2 mb-1"
            :href="'/#/requisitions/' + requisition.id"
          >
            <v-icon x-small class="pe-1">fa-align-left</v-icon>
            {{ $t("Opt.details") }}
          </v-btn>
        </template>
        <span>{{ $t("CRUD.viewInfo", [$t("Requisition.ObjectName")]) }}</span>
      </v-tooltip>
      <!-- 物流 -->
      <v-tooltip
        top
        v-if="
          showLogistic &&
          $permission.permissionAllow('Requisitions', 'editLogistics')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            :outlined="!requisition.logistics_json"
            color="orange"
            class="px-2 me-2 mb-1"
            @click.stop="editLogisticAlert = true"
          >
            {{ $t("Distribution.actions.logistic") }}
          </v-btn>
        </template>
        <span>{{ $t("Distribution.actions.logistic") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="showEdit && $permission.permissionAllow('Requisitions', 'edit')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="primary"
            class="px-2 me-2 mb-1"
            @click.stop="
              $permission.checkAccountExpired().then(() => {
                detailMode
                  ? $emit('edit')
                  : $router.push('/requisitions/' + requisition.id + '/edit');
              })
            "
          >
            <v-icon x-small class="pe-1">fa-pencil-alt</v-icon>
            {{ $t("Requisition.actions.edit") }}
          </v-btn>
        </template>
        <span>{{ $t("Requisition.actions.editRequisition") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showApprove && $permission.permissionAllow('Requisitions', 'approve')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="action"
            class="px-2 me-2 mb-1"
            @click.stop="doAction('approve')"
          >
            <v-icon x-small class="pe-1">fa-stamp</v-icon>
            {{ $t("Requisition.actions.approve") }}
          </v-btn>
        </template>
        <span>{{ $t("Requisition.actions.approveRequisition") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showCancel && $permission.permissionAllow('Requisitions', 'cancel')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="danger"
            class="px-2 me-2 mb-1"
            @click.stop="cancelAlert = true"
          >
            <v-icon x-small class="pe-1">fa-exclamation</v-icon>
            {{ $t("Requisition.actions.cancel") }}
          </v-btn>
        </template>
        <span>{{ $t("Requisition.actions.cancelRequisition") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showStockOut &&
          settings &&
          !settings.stock_position_setting &&
          $permission.permissionAllow('StockOuts', 'out')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="action"
            class="px-2 me-2 mb-1"
            @click.stop="
              $router.push({
                path:
                  '/stock-orders-out/' +
                  requisition.stock_out_order_id +
                  '/out',
                query: { outType: 'requisitionOut' },
              })
            "
          >
            {{ $t("Requisition.actions.stockOut") }}
          </v-btn>
        </template>
        <span>{{ $t("Requisition.actions.stockOut") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showStockIn &&
          settings &&
          settings.stock_position_setting &&
          $permission.permissionAllow('StockIns', 'shelveOn')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="action"
            class="px-2 me-2 mb-1"
            :href="
              '/#/putaway?stock_order_code=' +
              requisition.to_stock_order.stock_order_code +
              '&stock_id=' +
              requisition.to_stock_order.stock_id +
              '&stock_in_type=' +
              requisition.to_stock_order.type
            "
          >
            {{ $t("Requisition.actions.stockIn") }}
          </v-btn>
        </template>
        <span>{{ $t("Requisition.actions.stockIn") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showStockIn &&
          settings &&
          !settings.stock_position_setting &&
          $permission.permissionAllow('StockIns', 'in')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="action"
            class="px-2 me-2 mb-1"
            :href="'/#/stock-orders-in/' + requisition.stock_in_order_id + '/in'"
          >
            {{ $t("Requisition.actions.stockIn") }}
          </v-btn>
        </template>
        <span>{{ $t("Requisition.actions.stockIn") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showReturn &&
          $permission.permissionAllow('Requisitions', 'getReturnableList')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="action"
            class="px-2 me-2 mb-1"
            @click.stop="detailMode
              ? $emit('return')
              : $router.push('/requisitions/' + requisition.id + '/return');
            "
          >
            {{ $t("Requisition.actions.return") }}
          </v-btn>
        </template>
        <span>{{ $t("Requisition.actions.return") }}</span>
      </v-tooltip>
      <v-tooltip top v-if="showExport">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="print"
            class="px-2 me-2 mb-1"
            @click.stop="examineExport()"
          >
            <v-icon x-small class="pe-1">fa-file-excel</v-icon>
            {{ $t("Requisition.actions.exportDetail") }}
          </v-btn>
        </template>
        <span>{{ $t("Requisition.actions.exportDetail") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showExport &&
          $permission.permissionAllow('Requisitions', 'sanlianDetailExport')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="print"
            class="px-2 me-2 mb-1"
            @click.stop="requisitionSanlianExport()"
          >
            <v-icon x-small class="pe-1">fa-file-excel</v-icon>
            {{ $t("Requisition.actions.exportSanlianDetail") }}
          </v-btn>
        </template>
        <span>{{ $t("Requisition.actions.exportSanlianDetail") }}</span>
      </v-tooltip>
    </v-sheet>

    <DialogDelete
      v-model="cancelAlert"
      cancel-mode
      :label="$t('Requisition.ObjectName')"
      :code="requisition.requisition_code"
      @confirm="
        cancelAlert = false;
        doAction('cancel');
      "
    />
    <!-- 确认出库 -->
    <v-dialog v-model="stockOutDialog" max-width="480px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("$vuetify.alert") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="stockOutDialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="px-4 py-8 text-center subtitle-1">
          <v-row>
            <v-col class="pa-2 d-flex">
              <span class="secondary--text">
                {{ $t("StockOrderOUT.Fields.executer_name")
                }}{{ $t("Global.colon") }}
              </span>
              <SearcherAccountUser
                v-model="executeUserSelected"
                :type="[1, 2]"
                noLabel
                single-line
                dense
                hide-details
                class="d-inline mt-0 mb-n1"
                unclearable
              />
            </v-col>
          </v-row>
          <v-row class="my-2">
            <v-col class="pa-2">
              <span class="danger--text">
                {{ $t("StockOrderOUT.Messages.stock_order_out_confirm_out") }}
              </span>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="stockOutDialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
          <v-btn
            color="accent"
            depressed
            @click="
              confirmOut();
              stockOutDialog = false;
            "
          >
            {{ $t("$vuetify.confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 确认入库 -->
    <v-dialog v-model="stockInDialog" max-width="480px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("$vuetify.alert") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="stockInDialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="px-4 py-8 text-center subtitle-1">
          <v-row>
            <v-col class="pa-2 d-flex">
              <span class="secondary--text">
                {{ $t("StockOrderOUT.Fields.executer_name")
                }}{{ $t("Global.colon") }}
              </span>
              <SearcherAccountUser
                v-model="executeUserSelected"
                :type="[1, 2]"
                noLabel
                single-line
                dense
                hide-details
                class="d-inline mt-0 mb-n1"
                unclearable
              />
            </v-col>
          </v-row>
          <v-row class="my-2">
            <v-col class="pa-2">
              <span class="danger--text">{{
                $t("StockOrderIN.Messages.stock_order_in_confirm_in")
              }}</span>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="stockInDialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
          <v-btn
            color="accent"
            depressed
            @click="
              confirmIn();
              stockInDialog = false;
            "
          >
            {{ $t("$vuetify.confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <EditLogisticAlert
      v-model="editLogisticAlert"
      :requisitionId="requisition.id"
      @editLogistic="$emit('editLogistic')"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import Requisitions from "@/api/requisitions";
import DialogDelete from "@/components/plugins/DialogDelete";
import StockOuts from "@/api/stock_outs";
import StockIns from "@/api/stock_ins";
import SearcherAccountUser from "@/components/plugins/SearcherAccountUser";
import EditLogisticAlert from "./EditLogisticAlert";

export default {
  name: "RequisitionActions",

  props: {
    requisition: Object,
    detailMode: Boolean,
    showView: Boolean,
    showLogistic: Boolean,
    showEdit: Boolean,
    showApprove: Boolean,
    showCancel: Boolean,
    showStockOut: Boolean,
    showStockIn: Boolean,
    showExport: Boolean,
    showReturn: Boolean,
  },

  components: {
    DialogDelete,
    SearcherAccountUser,
    EditLogisticAlert,
  },

  computed: {
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings", "accountUser"]),
  },

  data: () => ({
    cancelAlert: false,
    stockOutDialog: false,
    stockInDialog: false,
    editLogisticAlert: false,
  }),

  methods: {
    actionMethod(mode) {
      if (mode == "cancel") return Requisitions.cancel(this.requisition.id);
      else if (mode == "approve")
        return Requisitions.approve(this.requisition.id);
    },
    doAction(mode) {
      this.$permission.checkAccountExpired().then(
        function () {
          this.actionMethod(mode).then(
            function (response) {
              if (response.data.status.isOK()) {
                if (this.detailMode) this.$router.push("/requisitions");

                this.$emit("done");
              }
            }.bind(this)
          );
        }.bind(this)
      );
    },
    confirmOut() {
      StockOuts.fetchOne(this.requisition.from_stock_order.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            StockOuts.out(response.data.stock_out).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.$emit("done");
                }
              }.bind(this)
            );
          }
        }.bind(this)
      );
    },
    confirmIn() {
      StockIns.fetchOne(this.requisition.to_stock_order.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            StockIns.stockIN(response.data.stock_in).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.$emit("done");
                }
              }.bind(this)
            );
          }
        }.bind(this)
      );
    },
    examineExport() {
      Requisitions.exportDetail(this.requisition.id);
    },
    requisitionSanlianExport() { 
      Requisitions.exportSanlianDetail(this.requisition.id);
    }
  },

  watch: {
    accountUser: {
      immediate: true,
      handler() {
        this.executeUserSelected = this.accountUser ? this.accountUser : null;
      },
    },
  },
};
</script>